import { render } from "./Host.vue?vue&type=template&id=3473b510"
import script from "./Host.vue?vue&type=script&lang=js"
export * from "./Host.vue?vue&type=script&lang=js"

import "./Host.vue?vue&type=style&index=0&id=3473b510&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__